import script from "./3d.vue?vue&type=script&setup=true&lang=js"
export * from "./3d.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__